import React from 'react';
import './Checkbox.css';

const Checkbox = ({ label, checked, onChange, id, className = '', checkboxStyle={} }) => {
  const checkboxId = id || `checkbox-${label?.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <label htmlFor={checkboxId} className={`checkbox-container ${className}`}>
      <input
        id={checkboxId}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        style={{...checkboxStyle}}
      />
      {label}
    </label>
  );
};

export default Checkbox;
